<template>
<div class="place place--float">
  <bk-search-field
    icon="gps_fixed"
    v-model="searchTerm"
    :label="label"
    :helper-text="helperText"
    :watch-value="true"
    :list="locations"
    :valid="valid"
    @input="loadPlaceList"
    @change="updateState"
    @click="updateLocation"
    :id="id"
    :loading="loading"
    :allow-hotjar-recording="allowHotjarRecording"
  />
</div>
</template>
<script>
import BkSearchField from '../../../common/BkSearchField'

export default {
  components: { BkSearchField },
  data () {
    return {
      /**
       * Array of possible location
       */
      locations: [],
      /**
       * Term to search for a location
       */
      searchTerm: '',
      /**
       * Selected value of a place
       */
      geoId: '',

      loading: false,
    }
  },
  props: {
    /**
     * Allow recording in HotJar by setting the appropriate classes to the input field
     */
    allowHotjarRecording: {
      type: Boolean,
      default: false
    },
    /**
     * The country where the search place is located
     */
    country: {
      type: String,
      default: 'D',
    },
    /*
    * Label of the input field
    */
    label: String,
    /**
     * Content of the helper text
     */
    helperText: String,
    /**
     * If true the location is valid
     */
    valid: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: '',
    },
    initialCity: {
      type: String,
      default: '',
    },
    initialGeoId: {
      type: Number,
      default: 0,
    }
  },
  mounted() {
    if(!this.initialCity.isEmpty() && this.initialGeoId > 0) {
      this.updateLocation({
        city: this.initialCity,
        geoId: this.initialGeoId
      })
    } else {
      this.updateLocation(null)
    }
  },
  methods: {
    /**
     * Load the list of the places that match the search term
     * @param searchTerm {string}
     */
    loadPlaceList (searchTerm) {
      this.locations = [];
      if (searchTerm === '') {
        this.loading = false
        return
      }
      this.loading = true
      const limit = 302;// max district count of city in DACH and PL
      this.requestGetLocation(this.country, searchTerm, limit)
        .then(data => {
          this.locations = data
          this.loading = false
        })
    },
    /**
     * Update the location
     */
    updateLocation (location) {
      if (!location) return
      this.geoId = location.geoId
      this.searchTerm = location.city
      this.updateState()
    },
    /**
     * Fire the change event and set pristine to false
     */
    updateState () {
      this.$emit('change', {geoId: this.geoId, city: this.searchTerm })
      this.pristine = false
    },
  },
  watch: {
    /**
     * If the country has change the place reset to the start value
     */
    country () {
      this.geoId = -1
      this.searchTerm = ''
      this.locations = []
      this.updateState()
      this.pristine = true
    }
  }
}
</script>

<style lang="scss">
  @import "../../../scss/colors";

  .place {
    -webkit-transition: .3s;
    transition: .3s;
    -webkit-transition-timing-function: ease-in-out;
    transition-timing-function: ease-in-out;
    width: 100%;
    position: relative;
    margin-bottom: 16px;

    &__list {
      width: 100%;
    }

    &--float {
      background-color: $surface;

      & .bk-reg-place__list {
        overflow-y: scroll;
        height: 100%;
        z-index: 2;
      }
    }
  }
</style>
